import { render, staticRenderFns } from "./TeacherToFollow.vue?vue&type=template&id=fd6ac9f2&"
import script from "./TeacherToFollow.vue?vue&type=script&lang=js&"
export * from "./TeacherToFollow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports